<template>
    <div class="w-full lg:mr-16">
        <div v-if="!embed" class="mb-12">
            <h1
                class="block text-2xl lg:text-4xl font-bold"
                :style="{
                    color: footer.mainColor,
                }"
            >
                {{ title }}
            </h1>
        </div>
        <section aria-labelledby="section-1-title">
            <dl class="space-y-6 divide-y divide-gray-200">
                <DocumentSection
                    :id="`sec${index}`"
                    v-for="(section, index) in sections.filter((x) => x.points)"
                    :key="index"
                    :footer="footer"
                    :section="section"
                    :index="index"
                    :view="view"
                    @updateIframeHeight="$emit('updateIframeHeight')"
                />
                <slot></slot>
            </dl>
        </section>
    </div>
</template>

<script>
import DocumentSection from "./DocumentSection.vue";

export default {
    name: "TermsContent",
    props: {
        view: String,
        footer: Object,
        sections: Array,
        title: String,
        embed: Boolean,
    },
    emits: ["updateIframeHeight"],
    components: {
        DocumentSection,
    },
};
</script>
